module.exports = __webpack_public_path__ + "img/hércules-florence.1cf62c38.png";